export class KeywiFirmware {
  constructor(
    public version: string = '0102',
    public batteryLifetimeInDays: number = 240,
  ) {}
}
